import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../utills";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Fetch user role from API (if needed)
  useEffect(() => {
    const storedUser = localStorage.getItem("login_data");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  // 🔹 Login function (Moved from LoginForm)
  const logIn = async (values) => {
    setLoading(true);
    try {
      const res = await axios.post(baseUrl + "signin", values);
      if (res?.status === 200) {
        setUser(res.data.user);
        localStorage.setItem("user_id", res?.data?.user?.user_id);
        localStorage.setItem("access_token", res?.data?.access_token);
        localStorage.setItem("login_data", JSON.stringify(res?.data));
        localStorage.setItem("role", res?.data?.user?.role);

        navigate(res?.data?.user?.role === "admin" ? "/" : "/layout");
      }
    } catch (error) {
      console.error("Login Error:", error);
      return error?.response?.data?.detail;
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Google Login function
  const handleLoginWithGoogle = async () => {
    setLoading(true);
    try {
      const res = await axios.get(baseUrl + "login_with_google");
      if (res?.status === 200) {
        setUser(res.data.user);
        navigate("/layout");
      }
    } catch (error) {
      console.error("Google Login Error:", error);
      return error?.response?.data?.detail;
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, logIn, handleLoginWithGoogle, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
